define(
    '../../widgets/range-slider/main',['jquery'], function ($) {
        'use strict';

        return function () {
            $('.range-slider').each(function () {
               var sliderId = $(this).attr('id'),
                   outputId = sliderId + '-output',
                   output = $('#' + outputId);

                $(this).on('change', function () {
                    output.val($(this).val());
                });
            });
        };
    }
);
